import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@mui/icons-material/Settings';
import {
    Box,
    Tooltip,
    Chip,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    OutlinedInput
} from '@mui/material';

import MemoryIcon from '@mui/icons-material/Memory';
import RouterIcon from '@mui/icons-material/Router';
import SpeakerIcon from '@mui/icons-material/Speaker';
import SecurityIcon from '@mui/icons-material/Security';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

import api from '../../../services/api';
import NavegadorGestao from "../../../components/NavBarGestao";
import EditIcon from '@mui/icons-material/Edit';
import { Button } from "@material-ui/core";
import { MaterialReactTable } from 'material-react-table';

export default function ListarModulos() {
    const [loading, setLoading] = useState(true);
    const [objetos, setObjetos] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [tiposSelecionados, setTiposSelecionados] = useState([]);

    const tiposMapeamento = {
        'ModuloPGM': 'ModuloPGM',
        'ModuloGatewaySentinel': 'ModuloGatewaySentinel',
        'ModuloSentinel': 'ModuloSentinel',
        'ModuloSonoro': 'ModuloSonoro'
    };

    async function listarObjetos() {
        if (!objetos.length) {
            setLoading(true);
        } else {
            setIsRefetching(true);
        }

        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            const response = await api.get("v1/protected/modulos/listartodas", { headers });
            setObjetos(response.data);
            setLoading(false);
            setIsRefetching(false);
            setIsError(false);
        } catch (_err) {
            console.log("Erro ao listar módulos: " + _err);
            setLoading(false);
            setIsRefetching(false);
            setIsError(true);
        }
    }

    const getTipoIcon = (tipo) => {
        switch (tipo) {
            case 'ModuloPGM': return <MemoryIcon fontSize="small" />;
            case 'ModuloGatewaySentinel': return <RouterIcon fontSize="small" />;
            case 'ModuloSentinel': return <SecurityIcon fontSize="small" />;
            case 'ModuloSonoro': return <VolumeUpIcon fontSize="small" />;
            default: return <MemoryIcon fontSize="small" />;
        }
    }

    useEffect(() => {
        listarObjetos();
    }, []);

    const filteredData = useMemo(() => {
        if (tiposSelecionados.length === 0) return objetos;
        return objetos.filter(item => tiposSelecionados.includes(item.tipo));
    }, [objetos, tiposSelecionados]);

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'ID',
                size: 80,
            },
            {
                accessorKey: 'tipo',
                header: 'Tipo',
                size: 200,
                Cell: ({ cell }) => (
                    <Chip
                        icon={getTipoIcon(cell.getValue())}
                        label={cell.getValue()}
                        size="small"
                        variant="outlined"
                    />
                ),
            },
            {
                accessorKey: 'codigo',
                header: 'Código',
                size: 150,
            },
            {
                accessorKey: 'marca',
                header: 'Marca',
                size: 150,
            },
            {
                accessorKey: 'modelo',
                header: 'Modelo',
                size: 150,
            },
            {
                accessorKey: 'data_fabricacao',
                header: 'Data Fabricação',
                size: 150,
            },
        ],
        [],
    );

    const handleButtonClick = () => {
        window.location.href = "/tecnica/modulos/cadastrar";
    }

    const handleEdit = (row) => {
        window.location.href = `/tecnica/modulos/editar/${row.original.tipo}/${row.original.id}`;
    }

    return (
        <div>
            <NavegadorGestao
                AreaTecnica={true}
                Modulos={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />

            <div style={{ padding: 20 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                        Gestão de Módulos
                    </Typography>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => window.location.href = "/tecnica/modulos/testar"}
                            style={{ height: 40, backgroundColor: '#f59e0b' }}
                        >
                            Testar Módulo
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleButtonClick}
                            style={{ height: 40 }}
                        >
                            Cadastrar Novo Módulo
                        </Button>
                    </div>
                </Box>

                {loading ?
                    <Skeleton animation="wave" width="100%" height={400} />
                    :
                    <MaterialReactTable
                        columns={columns}
                        data={filteredData}
                        enableRowActions
                        renderRowActions={({ row }) => (
                            <Tooltip title="Editar">
                                <IconButton onClick={() => handleEdit(row)}>
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                        renderTopToolbarCustomActions={() => (
                            <Box sx={{ display: 'flex', gap: '1rem', p: '4px' }}>
                                <FormControl sx={{ minWidth: 200 }} size="small">
                                    <InputLabel id="label-tipo-multi">Filtrar por Tipo</InputLabel>
                                    <Select
                                        labelId="label-tipo-multi"
                                        multiple
                                        value={tiposSelecionados}
                                        onChange={(e) => setTiposSelecionados(e.target.value)}
                                        input={<OutlinedInput label="Filtrar por Tipo" />}
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {selected.map((value) => (
                                                    <Chip key={value} label={value} size="small" />
                                                ))}
                                            </Box>
                                        )}
                                    >
                                        {Object.keys(tiposMapeamento).map((tipo) => (
                                            <MenuItem key={tipo} value={tipo}>
                                                <Checkbox checked={tiposSelecionados.indexOf(tipo) > -1} />
                                                <ListItemText primary={tipo} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        )}
                        initialState={{ density: 'compact', showGlobalFilter: true }}
                        muiTableContainerProps={{ sx: { maxHeight: 'calc(100vh - 250px)' } }}
                    />
                }
            </div>
        </div>
    );
}
